import { useRef as w, useEffect as I } from "react";
const l = "prod", A = '[data-qm="track-ucl"]', N = "data-qm-label", C = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  URL_NOT_FOUND: 420,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504
}, g = {
  "check-url": {
    "X-Identified-By": "ucl-check-url"
  },
  "track-component": {
    "X-Identified-By": "ucl-track-component"
  }
}, p = {
  prod: {
    serverUrl: "https://api-prd.fordpro.com",
    publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArSHXH3+XW9EEif7kjglk
Whx2Mi6PICZmypD9x4JJXOS5Jo9QICu3xXBvzyODYVr1xnmN6cMNxdC1pG59bmBT
41XV4vuGsBg2/kuYFnIHfVTlzc+yn6jIa6KbNEfNwQCJIKXRKCzVxRla1lcE2Eti
bqsaIvIkFYwIwVuY3eRcYEwHiHxBrKFbqqtDT47OqSN1fqRNGoy7dcxSq8Spya8B
xZAd0VWpS7+Z0T2tEQ3ADs8NK12g8gV2J37CZlR7wFVbJhDSuu9O/ETZFRxkiORW
b/brZM7sIdZq8v56E5rT/Z6LgqyO9zqsv27X5xcnqqPmSvsAFW3VefIc0kFbzymO
aQIDAQAB
-----END PUBLIC KEY-----`
  },
  dev: {
    serverUrl: "https://api-dev.fordpro.com",
    publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm5VkoYA6e0cy/ql0aozU
rhM+bjElbRPAhSyiwjCIZ2+IHV0LKV1hZaZCJJ7/sQ2DY08wpksjKTF+3rLqCCGG
7oCuGLW0Zi8udPn2/X9Cp7ztVpyzLYAEpVi2d8dxHmsLqp8QXWyeeRXfG2BGhKSD
bxOQxluFi8fPxgCGdfQSYcnesIvJjemQm+Kyoiz6kmc5QNkmAXfaXurKzaXL/YJI
kuGV1OKgH3NvAMkdglB0klUe0fW7xDG4b8gHgMna4Gs77UFf0ifF/kQRBt+ZRrTN
+NPx3rEJTM/ETWvQvH/CJCmtM0u9Jdl9ufOKbcpW43XkZhi02Lx6+pQKEozC235P
FQIDAQAB
-----END PUBLIC KEY-----`
  },
  local: {
    serverUrl: "http://localhost:8080",
    publicKey: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm5VkoYA6e0cy/ql0aozU
rhM+bjElbRPAhSyiwjCIZ2+IHV0LKV1hZaZCJJ7/sQ2DY08wpksjKTF+3rLqCCGG
7oCuGLW0Zi8udPn2/X9Cp7ztVpyzLYAEpVi2d8dxHmsLqp8QXWyeeRXfG2BGhKSD
bxOQxluFi8fPxgCGdfQSYcnesIvJjemQm+Kyoiz6kmc5QNkmAXfaXurKzaXL/YJI
kuGV1OKgH3NvAMkdglB0klUe0fW7xDG4b8gHgMna4Gs77UFf0ifF/kQRBt+ZRrTN
+NPx3rEJTM/ETWvQvH/CJCmtM0u9Jdl9ufOKbcpW43XkZhi02Lx6+pQKEozC235P
FQIDAQAB
-----END PUBLIC KEY-----`
  }
}, d = (() => {
  let n = "", e = "";
  return {
    getProductTeamName: () => n,
    setProductTeamName: (t) => {
      n = t;
    },
    getThemeName: () => e,
    setThemeName: (t) => {
      e = String(t);
    }
  };
})(), h = () => p[l].serverUrl, y = () => p[l].publicKey, f = async () => {
  const e = y().replace("-----BEGIN PUBLIC KEY-----", "").replace("-----END PUBLIC KEY-----", "").replace(/\n/g, ""), t = Uint8Array.from(atob(e), (o) => o.charCodeAt(0));
  return window.crypto.subtle.importKey(
    "spki",
    t,
    {
      name: "RSA-OAEP",
      hash: "SHA-256"
    },
    !0,
    ["encrypt"]
  );
}, T = async (n, e) => {
  const o = new TextEncoder().encode(n), r = await window.crypto.subtle.encrypt(
    {
      name: "RSA-OAEP"
    },
    e,
    o
  );
  return btoa(String.fromCharCode(...new Uint8Array(r)));
}, B = h(), k = async (n, e, t, o) => {
  const r = {
    method: e,
    headers: {
      "Content-Type": "application/json",
      ...o
    }
  };
  e === "post" && t && (r.body = JSON.stringify(t));
  try {
    const c = await fetch(n, r);
    return {
      data: await c.json().catch(() => null),
      status: c.status,
      statusText: c.statusText
    };
  } catch (c) {
    console.log(c);
  }
}, K = async (n, e) => {
  if (!e.length)
    return;
  let t = [...e];
  {
    const r = await f();
    t = await Promise.all(
      e.map(async (c) => ({
        ...c,
        productName: await T(c.productName, r)
      }))
    );
  }
  return await k(`${B}/track-component`, "post", t, {
    "X-Current-URL": n,
    "X-Page-Title": document.title || "NA",
    ...g["track-component"]
  });
}, D = () => new Promise((n, e) => {
  const t = indexedDB.open("URLTrackerDB", 1);
  t.onupgradeneeded = (o) => {
    const r = o.target.result;
    r.objectStoreNames.contains("urls") || r.createObjectStore("urls", { keyPath: "url" });
  }, t.onsuccess = (o) => {
    n(o.target.result);
  }, t.onerror = (o) => {
    var r;
    e("Database error: " + ((r = o.target.error) == null ? void 0 : r.message));
  };
}), U = (n, e) => new Promise((t, o) => {
  const s = n.transaction(["urls"], "readonly").objectStore("urls").get(e);
  s.onsuccess = () => {
    t(s.result !== void 0);
  }, s.onerror = () => {
    o("Error checking URL: " + s.error);
  };
}), b = (n, e) => {
  n.transaction(["urls"], "readwrite").objectStore("urls").add({ url: e });
}, L = async () => {
  try {
    const n = window.location.origin + window.location.pathname, e = await D();
    if (await U(e, n))
      return;
    const o = P(), r = await K(n, o);
    (r == null ? void 0 : r.status) === C.OK && b(e, n);
  } catch (n) {
    console.error("Error in trackPage:", n);
  }
}, P = () => {
  const n = document.querySelectorAll(A), e = [];
  return n.forEach((t) => {
    var i;
    const r = (i = t.attributes.getNamedItem(N)) == null ? void 0 : i.value.replace(/^UCL-/, "");
    if (!r)
      return;
    const c = d.getProductTeamName() || "NA", s = d.getThemeName() || "NA", a = e.find((u) => u.productName === c);
    a ? a.components.includes(r) || a.components.push(r) : e.push({
      productName: c,
      themeName: s,
      components: [r]
    });
  }), e;
}, v = (n, e) => {
  const t = w(n);
  I(() => {
    var s;
    if (e)
      return;
    const o = window.location.origin + window.location.pathname;
    if (window.lastPageUrl === o || (window.lastPageUrl = o, !(typeof window < "u" && window.document && window.document.createElement)))
      return;
    if (!window.__historyOverridden) {
      const a = (i) => {
        const u = window.history[i];
        window.history[i] = function(...m) {
          const E = u.apply(window.history, m);
          return window.dispatchEvent(new Event("locationchange")), E;
        };
      };
      a("pushState"), a("replaceState"), window.__historyOverridden = !0;
    }
    const c = () => {
      var i;
      const a = window.location.href;
      (i = t.current) == null || i.call(t, a);
    };
    return window.addEventListener("popstate", c), window.addEventListener("locationchange", c), window.trackPage = L, (s = t.current) == null || s.call(t, window.location.href), () => {
      window.removeEventListener("popstate", c), window.removeEventListener("locationchange", c);
    };
  }, [e]);
};
export {
  y as getPublicKey,
  h as getServerUrl,
  d as metaData,
  v as useUrlChangeListener
};
